import {
  CalciteAutocomplete,
  CalciteAutocompleteItem,
  CalciteLabel,
} from "@esri/calcite-components-react";
import React from "react";
import { AutocompleteProps } from "./Autocomplete.d";

const Autocomplete: React.FC<AutocompleteProps> = ({
  label,
  value,
  onChange,
  optionFetch,
  scale = "m",
  labelSize = "m",
  copyable = true,
  lastFired = new Date().toString(),
  onTabPress = () => {},
  ...remainingProps
}) => {
  const [options, setOptions] = React.useState<string[]>([]);
  const [loading, setLoading] = React.useState(false);

  function getOptions() {
    setLoading(true);
    optionFetch(value)
      .then((res) => {
        // success -> return data
        setOptions(res);
        setLoading(false);
      })
      .catch((err) => {
        // error -> return error message
        console.error("Unable to fetch autocomplete options", err);
        setLoading(false);
      });
  }

  React.useEffect(() => {
    getOptions();
  }, [value, lastFired]);

  return (
    <CalciteLabel
      scale={labelSize}
      style={{
        cursor: copyable ? "pointer" : "default",
      }}
      onClick={
        copyable
          ? (e) => {
              if (e.target === e.currentTarget) {
                if (!value) return;
                navigator.clipboard.writeText(value || "");
              }
            }
          : undefined
      }
    >
      {label}
      <CalciteAutocomplete
        name="autocomplete"
        autocomplete="off"
        placement="bottom-end"
        flipPlacements={["bottom-end"]}
        value={value}
        inputValue={value}
        scale={scale}
        onCalciteAutocompleteChange={(event) => {
          onChange(event.target.value);
        }}
        onCalciteAutocompleteTextInput={(event) => {
          onChange(event.target.inputValue);
        }}
        style={{ opacity: "1" }}
        {...remainingProps}
        onKeyDown={(event) => {
          if (event.key === "Tab") {
            onTabPress();
          }
        }}
      >
        {options &&
          options.length > 0 &&
          options.map((option, index) => (
            <CalciteAutocompleteItem
              key={index}
              heading={option}
              value={option}
            />
          ))}
        {value !== "" && options && options.length === 0 && !loading && (
          <CalciteAutocompleteItem
            heading="No results"
            value={value}
            className="temporary"
            disabled
          />
        )}
      </CalciteAutocomplete>
    </CalciteLabel>
  );
};

export default Autocomplete;
